// extracted by mini-css-extract-plugin
export default {"wrap":"ResponsiveTable_wrap__IC7IX","table":"ResponsiveTable_table__Yuglq","detailRow":"ResponsiveTable_detailRow__1fEW3"};